export { CompareTray, CompareTraySpacer } from './CompareTray'
